import PostsSerializer from './base';

export default class PostTemplate extends PostsSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      editableRoot: false,
      isLocked: false,
      visibleToParents: false,
      visibleToLearners: false,
      jurisdictions: [],
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
